import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
};

// mutations
const mutations = {

};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
